import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Modal, Spin } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import MarketplaceFeesTable from "../vehicleHires/MarketplaceFeesTable";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector } from "../../../../store/slice/auth";
import ConsignmentMarketplaceFeesResource from "./api/ConsignmentMarketplaceFeesResource";
import { FeeType } from "../orders/api/Representation";
import ConsignmentHasBeenInvoicedAlert from "./ConsignmentHasBeenInvoicedAlert";
import { ConsignmentStatusEnum } from "./api/Representation";
export const ConsignmentMarketplaceFeesTable = ({ consignment, canEdit = true }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const [modal, contextHolder] = Modal.useModal();
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [fees, setFees] = useState([]);
    useEffect(() => {
        if (consignment.id) {
            loadFees();
        }
    }, [consignment.id]);
    const loadFees = () => {
        setNetworkRequestInProgress(true);
        ConsignmentMarketplaceFeesResource.list(consignment.id, setFees, axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const transformFee = (fee) => {
        return {
            description: fee.description,
            type: fee.type,
            chargeAmountExTax: fee.chargeAmountExTax,
            providerAmountExTax: fee.providerAmountExTax,
            providerTenantId: fee.providerTenant?.id,
            providerAccountsType: fee.providerAccountsType,
            unitOfMeasure: fee.type === FeeType.PER_UOM ? fee.unitOfMeasure : null,
            version: fee.version
        };
    };
    const onFeeAdded = (fee) => {
        setNetworkRequestInProgress(true);
        ConsignmentMarketplaceFeesResource.create(consignment.id, transformFee(fee), ( /*fee: MarketplaceFeeResponse*/) => loadFees(), axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const onFeeUpdated = (fee) => {
        setNetworkRequestInProgress(true);
        ConsignmentMarketplaceFeesResource.update(consignment.id, fee.id, transformFee(fee), ( /*fee: SalesOrderFeeResponse*/) => loadFees(), axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const deleteFee = (fee) => {
        setNetworkRequestInProgress(true);
        ConsignmentMarketplaceFeesResource.delete(consignment.id, fee.id, () => loadFees(), axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const onFeeRemoved = (fee) => {
        modal.confirm({
            title: 'Are you sure?',
            content: `Delete fee ${fee.description} from this delivery? This cannot be undone.`,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => deleteFee(fee)
        });
    };
    return (_jsxs(Spin, { spinning: networkRequestInProgress, children: [contextHolder, consignment.marketplaceListings?.length > 0 &&
                _jsx(ConsignmentHasBeenInvoicedAlert, { consignmentId: consignment.id, consignmentStatus: consignment.status }), _jsx(MarketplaceFeesTable, { fees: fees, onFeeAdded: onFeeAdded, onFeeUpdated: onFeeUpdated, onFeeRemoved: onFeeRemoved, canEdit: canEdit && userHasPermission(loggedInUser, ['subtruxOperations:consignment:fees:create', 'subtruxOperations:consignment:fees:update']), canRemove: canEdit && userHasPermission(loggedInUser, ['subtruxOperations:consignment:fees:delete']), showTotals: consignment.status === ConsignmentStatusEnum.COMPLETED })] }));
};
